<div class="d-flex w-100 h-100 justify-content-center align-content-center mt-4">
    <div class="chart-container d-flex justify-content-center " style="width: 72vw; ">
        <canvas [id]="canvasId">{{ chart }}</canvas>
    </div>
    <div>
        <button (click)="exportChart()" class="btn rounded-0 btn-outline-success ms-5   ms-sm-5 btn-sm"> Export
        </button>
    </div>
</div>
